module.exports = __webpack_public_path__ + "uPQDIod2JOJYdqZ-K/RDC_RED_Logo_House.svg";